export default __webpack_public_path__ + "static/media/ChildProtofoilo.3cc15828.jpg";